export default function isFloat(value) {
  return !/^\s*$/.test(value) && !Number.isNaN(Number(value));
}
